import { FEATURE_COUNTS } from './catalog';
import './samples.css';

export function FeatureOverview() {
  return <section id="features" className="sample-features" aria-label="Studio features">
    <article><span className="sample-feature-number">{FEATURE_COUNTS.maps}</span><h2>Map types</h2>
      <p>From bright street maps to contours, shaded terrain, topos, and satellite imagery.</p><a href="/samples#maps">Preview the maps →</a></article>
    <article><span className="sample-feature-number">{FEATURE_COUNTS.cameras}</span><h2>Camera platforms</h2>
      <p>You got a bunch of camera platforms: DJI Drone, UAV, Little Bird, Night Hawk. Adjust zoom, tilt, depth of field, and Camera Gimbal movement. Use keyframes for cuts and smooth transitions between views.</p><a href="/samples#explore">Try the cameras →</a></article>
    <article><span className="sample-feature-number">{FEATURE_COUNTS.layouts}</span><h2>Social layouts</h2>
      <p>Title, adventure statistics, and elevation placed with room for the platform’s own controls and captions.</p><a href="/samples#social">See the clear space →</a></article>
  </section>;
}
